import { Link, useLocation } from "react-router-dom";

export default function NotFound() {
  const location = useLocation();
  
  return (
    <div className="relative flex flex-col items-center justify-center h-screen text-center px-4 bg-dark-bg">
      <h1 className="absolute bottom-0 text-9xl md:text-[12rem] font-black text-charcoal-800 select-none pointer-events-none z-0">
        404
      </h1>
      <div className="relative z-10">
        <h1 className="text-xl md:text-2xl font-semibold mt-6 text-charcoal-50">This page has not been generated</h1>
        <p className="mt-2 text-base text-charcoal-400 font-mono">{location.pathname}</p>
        <p className="mt-4 text-lg md:text-xl text-charcoal-300">Tell me more about this page, so I can generate it</p>
        <Link
          to="/"
          className="inline-flex items-center gap-2 mt-8 px-6 py-3 bg-gold text-dark-bg text-sm font-sans font-semibold rounded-full hover:bg-gold-light transition-colors duration-300"
        >
          <i className="ri-arrow-left-line text-xs"></i>
          Back to Home
        </Link>
      </div>
    </div>
  );
}